<div class="side-nav-container">
    <!-- ACTION -->
    <div class="side-nav-sub-container">
        <button (click)="onClickActions()" class="primary-button" [ngClass]="{'button-click':buttonStatus == 'action'}">
            {{strings["actions"]}}
        </button>
        <div *ngIf="this.subMenu == 'action'" class="side-nav-click-container">
            <input type="text" (keyup)=" filterActionSolutionsList($event.target.value)"
                placeholder="{{strings['search']}}" />
            <div *ngFor="let solution of filteredActionSolutions | async" class="side-nav-name-div">
                <span (click)="selectActionSolution(solution.name)"
                    [ngClass]="{'button-click': spanStatus == solution.name && actionsHighlight}">
                    {{solution.alias}}
                </span>
            </div>
        </div>
    </div>

    <!-- TABLES -->
    <div class="side-nav-sub-container">
        <button (click)="onClickTables()" class="primary-button" [ngClass]="{'button-click':buttonStatus == 'tables'}">
            {{strings["tables"]}}
        </button>
        <div *ngIf="this.subMenu == 'tables'" class="side-nav-click-container">
            <input type="text" (keyup)="filterTablesSolutionsList($event.target.value)"
                placeholder="{{strings['search']}}" />
            <div *ngFor="let table of filteredTableSolutions | async" class="side-nav-name-div">
                <span (click)="selectTable(table.id, table.name)"
                    [ngClass]="{'button-click':spanStatus == table.name && tablesHighlight == true}">
                    {{table.name}}
                </span>
            </div>
        </div>
    </div>

    <!-- DATA VALIDATION -->
    <div class="side-nav-sub-container">
        <button (click)="onClickDataValidation()" class="primary-button"
            [ngClass]="{'button-click':buttonStatus == 'rundata'}">
            {{strings["dataValidation"]}}
        </button>
        <div *ngIf="this.subMenu == 'rundata'" class="side-nav-click-container">
            <input type="text" (keyup)="filterDataValidationSolutionsList($event.target.value)"
                placeholder="{{strings['search']}}" />
            <div *ngFor="let entry of filteredDataValidationSolutionAliases | async | keyvalue: preserveOrder" class="side-nav-name-div">
                <span (click)="selectDataValidationSolution(entry.key)"
                    [ngClass]="{'button-click':spanStatus == entry.key && dataValidationsHighlight == true}">
                    {{entry.value}}
                </span>
            </div>  
        </div>
    </div>

    <!-- DATA LAKE || OUTPUT -->
    <div class="side-nav-sub-container">
        <button (click)="onClickOutput()" class="primary-button"
            [ngClass]="{'button-click':buttonStatus == 'dataLake'}">
            {{strings["output"]}}
        </button>
        <div *ngIf="this.subMenu == 'dataLake'" class="side-nav-click-container">
            <input type="text" (keyup)="filterOutputSolutionsList($event.target.value)"
                placeholder="{{strings['search']}}" />
            <div *ngFor="let entry of filteredDataLakeSolutions | async | keyvalue: preserveOrder" class="side-nav-name-div">
                <span (click)="selectDataLakeSolution(entry.key)"
                    [ngClass]="{'button-click':spanStatus == entry.key && outputsHighlight == true}">
                    {{entry.value}}
                </span>
            </div>
        </div>
    </div>

    <!-- RUN LOG -->
    <div class="side-nav-sub-container">
        <button (click)="onClickRunLog()" class="primary-button" [ngClass]="{'button-click':buttonStatus == 'runlog'}">
            {{strings["processLogs"]}}
        </button>
        <div *ngIf="this.subMenu == 'runlog'" class="side-nav-click-container">
            <input type="text" placeholder="{{strings['search']}}"
                (keyup)="filterRunLogSolutionsList($event.target.value)">
            <div *ngFor="let entry of filteredRunLogSolutions | async | keyvalue: preserveOrder" class="side-nav-name-div">
                <span (click)="selectRunLogSolution(entry.key)"
                    [ngClass]="{'button-click':spanStatus == entry.key && runLogHighlight == true }">
                    {{entry.value}}
                </span>
            </div>
        </div>
    </div>

    <!-- ERROR LOG -->
    <div class="side-nav-sub-container">
        <button (click)="onClickErrors()" class="primary-button" [ngClass]="{'button-click':buttonStatus == 'errors'}">
            {{strings["warningsAndErrors"]}}
        </button>
        <div *ngIf="this.subMenu == 'errors'" class="side-nav-click-container">
            <input type="text" (keyup)="filterErrorSolutionsList($event.target.value)"
                placeholder="{{strings['search']}}" />
            <div *ngFor="let entry of filteredErrorLogSolutions | async | keyvalue: preserveOrder" class="side-nav-name-div">
                <span (click)="selectErrorLogSolution(entry.key)"
                    [ngClass]="{'button-click':spanStatus == entry.key && errorHighlight == true}">
                    {{entry.value}}
                </span>
            </div>
        </div>
    </div>

    <!-- Admin -->
    <div class="side-nav-sub-container" *ngIf="showAdminNav">
        <button (click)="onClickAdmin()" class="primary-button" [ngClass]="{'button-click':buttonStatus == 'admin'}">
            {{strings["admin"]}}
        </button>
    </div>

    <!-- existing confirm modal (unchanged) -->
    <jw-modal id="confirm-switch">
        <div style="padding:16px; max-width:420px">
            <h3>Leave without saving?</h3>
            <p>You have unsaved changes in this table. If you continue, your edits will be discarded.</p>
            <div style="display:flex; gap:8px; justify-content:flex-end; margin-top:16px">
                <button class="primary-button" (click)="confirmSwitchResolve(true)">Leave</button>
                <button class="primary-button" (click)="confirmSwitchResolve(false)">Stay</button>
            </div>
        </div>
    </jw-modal>

</div>
